// lib/invoice-utils.ts

export type TransactionType = 'purchase' | 'sales';

export interface InvoiceLabels {
  party: string;
  invoice: string;
  date: string;
}

/**
 * Get dynamic labels based on transaction type
 * Purchase: Vendor/Supplier
 * Sales: Customer
 */
export function getInvoiceLabels(transactionType: TransactionType): InvoiceLabels {
  if (transactionType === 'sales') {
    return {
      party: 'Customer',
      invoice: 'Invoice',
      date: 'Invoice Date',
    };
  }

  return {
    party: 'Vendor',
    invoice: 'Bill',
    date: 'Bill Date',
  };
}
